"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeConfigOutSerializer = void 0;
exports.StripeConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=stripeConfigOut.js.map